<template>
  <div class="default-table radius_bg">
    <el-table ref="dress" v-loading="tableLoading" :data="dataList" style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" />
      <el-table-column align="center" label="序号" type="index" width="50" fixed="left" />
      <el-table-column min-width="360" label="基本信息" fixed="left">
        <template v-slot="{row:{cover_url,spec_name,title,updated_at,brand_name,platform_name}}">
          <div class="table-column__basic">
            <div style="width: 76px; height: 76px;overflow: hidden;display: inline-block">
              <el-image :fit="'contain'" style="width: 100%;height: 100%" :src="cover_url" :preview-src-list="[cover_url]">
                <div slot="error" class="image-slot">
                  <svg-icon icon-class="errorImg" style="font-size: 60px;display: block"></svg-icon>
                </div>
              </el-image>
            </div>
            <div class="table-column__basic-right" style="display:inline-block;">
              <p class="title">
                <span v-if="brand_name">{{ brand_name }}</span>
                {{ title }}
              </p>
              <p class="time">尺码颜色：<b>{{ spec_name }}</b></p>
              <p class="time">可播平台：<b>{{ String(platform_name) }}</b></p>
              <p class="time">更新时间：<b>{{ updated_at|parseTime('{y}/{m}/{d} {h}:{i}') }}</b></p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="samples" label="寄样明细" min-width="80" align="center" />
      <el-table-column prop="remark" label="备注" min-width="60" align="center" />
      <el-table-column min-width="130" label="预售返单">
        <template v-slot="{row:{wares_prep}}">
          <div v-if="typeof wares_prep==='string'">
            <div v-for="(tmp,tmp_i) in wares_prep.split(' ； ')" :key="tmp_i">
              {{ tmp || '' }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column min-width="200" label="现货库存">
        <template v-slot="{row:{wares_exist}}">
          <div v-if="typeof wares_exist==='string'">
            <div v-for="(tmp,tmp_i) in wares_exist.split(' ； ')" :key="tmp_i">
              {{ tmp || '' }}
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="delivery_cycle" label="发货时效" min-width="80" align="center" show-overflow-tooltip />
      <el-table-column min-width="130" label="价格">
        <template v-slot="{row:{price,lb_price,commission,support_situation}}">
          <p>日常价：<b>{{ price || '-' }}</b></p>
          <p>直播价：<b>{{ lb_price || '-' }}</b></p>
          <p>佣金：<b>{{ commission || '-' }}</b></p>
          <p>保价情况：<b>{{ support_situation || '-' }}</b></p>
        </template>
      </el-table-column>
      <el-table-column prop="leader_name" label="负责人" min-width="80" align="center" show-overflow-tooltip />
      <el-table-column min-width="100" label="操作" align="center" fixed="right">
        <template v-slot="{row}">
          <el-button type="text" icon="el-icon-edit" v-if="canEdit" @click="$emit('edit', row.id)">修改</el-button>
          <el-button type="text" icon="el-icon-delete" v-if="canDelete" @click="$emit('delete', row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'DressLibraryTable',
  props: {
    dataList: {
      type: Array,
      default: () => []
    },
    tableLoading: {
      type: Boolean,
      default: false
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentSelection: []
    }
  },
  methods: {
    handleSelectionChange(selection) {
      this.currentSelection = selection
    },
    getSelection() {
      return this.currentSelection
    },
    clearSelection() {
      this.$refs.dress.clearSelection()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/pages/lb/style/main.scss";

.default-table {
  margin: 0;
  padding: 0;
}
</style>

<style lang="scss">
@import "@/pages/lb/style/main.scss";

.table-column__basic {
  width: 100%;

  .el-image {
    width: 76px;
    border-radius: 6px;
    display: block;
  }

  &-right {
    max-width: calc(100% - 100px);
    margin-left: 10px;

    .title {
      color: #45474d;
      font-weight: 700;
      line-height: 1.4;
      font-size: 13px;
      margin-bottom: 4px;
      margin-top: 2px;

      span {
        font-size: 12px;
        background-color: $--status-lock-bg;
        border-radius: 13px;
        margin-right: 6px;
        padding: 3px 10px;
        color: $--color-text-regular;
      }
    }

    .time {
      margin: 10px 0;
      font-size: 12px;
      color: #8a8e99;
      background-color: $--background-color-extralight;
      border-radius: 4px;
      padding: 3px;

      > * {
        padding: 3px
      }
    }
  }
}

.image-slot {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
</style>
（内容由AI生成，仅供参考）
